import BaseResource from '@sigmacloud/sigma-client/dist/resources'

export default class AccountGroup extends BaseResource {
  static endpoint = '/accountgroup'
  static modelName = 'AccountGroup'
}



// WEBPACK FOOTER //
// ./src/resources/AccountGroupResource.js